import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@router/stackflow';
import { useQuery } from '@tanstack/react-query';

function useEvent(eventId: string) {
    const { data } = useQuery(queries.events.detail(eventId));
    const { pop } = useFlow();
    const toast = useToast();
    return data;
}

export default useEvent;
